// Language codes/labels for organization + preview pickers. Derived from the
// canonical language metadata in `@travel-planner/shared/schemas` (the single
// source of truth) — this module keeps NO language list of its own, it only
// re-shapes the shared data into the `{ code, label }` form these consumers
// expect. Order matches the canonical `LANGUAGE_META` (V2 parity).

import type { LanguageCode as SharedLanguageCode } from '@travel-planner/shared/schemas/facility';
import { languageName, toLanguageCode } from '@travel-planner/shared/schemas';
import { languageCodeValues } from '@travel-planner/shared/schemas/facility';

export const LANGUAGE_CODES = languageCodeValues;

export type LanguageCode = SharedLanguageCode;

export const LANGUAGE_OPTIONS: ReadonlyArray<{
  code: LanguageCode;
  label: string;
}> = LANGUAGE_CODES.map((code) => ({ code, label: languageName(code) }));

export const getLanguageLabel = (code: string | null | undefined): string => {
  const known = toLanguageCode(code);
  return known ? languageName(known) : (code ?? '');
};
